"use strict";

exports.__esModule = true;
var _actions = require("./actions");
Object.keys(_actions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _actions[key]) return;
  exports[key] = _actions[key];
});
var _ChangePartInstanceActionElement = require("./ChangePartInstanceActionElement");
Object.keys(_ChangePartInstanceActionElement).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ChangePartInstanceActionElement[key]) return;
  exports[key] = _ChangePartInstanceActionElement[key];
});